@keyframes work-launch-entrance {
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
}

[data-work-launch-entrance] {
  animation: work-launch-entrance 280ms cubic-bezier(.22, 1, .36, 1) backwards;
}

@media (prefers-reduced-motion: reduce) {
  [data-work-launch-entrance] { animation: none; }
}
